import Api from '../helpers/api';

export const monitorQrcodesService = {
	getMonitorQrcodes,
	postMonitorQrcode,
	putMonitorQrcode,
	deleteMonitorQrcode,
};

function getMonitorQrcodes(filter, cancelToken) {
	cancelToken = cancelToken === undefined ? null : cancelToken;

	return Api.get(`/preset/monitors/qrcodes`, { cancelToken });
}

function postMonitorQrcode(medicalPlan) {
	return Api.post(`/preset/monitors/qrcodes`, medicalPlan);
}

function putMonitorQrcode(medicalPlan) {
	return Api.put(`/preset/monitors/qrcodes/${medicalPlan.id}`, medicalPlan);
}

function deleteMonitorQrcode(id) {
	return Api.delete(`/preset/monitors/qrcodes/${id}`);
}
